// :cow: Cosmose CONFIDENTIAL :iso:
import { createAction, props } from '@ngrx/store';
import { TagListResponse } from '@par/app/core/model/dictionaries.response';

export const getTagListRequested = createAction('[SELECT TAG] Get Tag List Requested');
export const getTagListSucceeded = createAction('[SELECT TAG] Get Tag List Succeeded', props<{ response: TagListResponse }>());
export const getTagListFailed = createAction('[SELECT TAG] Get Tag List Failed');
